import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import FacetPlanAddBalanceTransfer from 'Views/Page/Content/Modal/Layouts/FacetPlanAddBalanceTransfer';

const AddFacetPlanBalanceTransferStep = () => {
  const { setModalCollection } = useModalContext();

  const onSubmit = async (res) => {
    setModalCollection(res);
  };

  return (
    <FacetPlanAddBalanceTransfer onSubmit={onSubmit} />
  );
};

AddFacetPlanBalanceTransferStep.defaultProps = {
};

AddFacetPlanBalanceTransferStep.propTypes = {
};

export default AddFacetPlanBalanceTransferStep;
